// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"document-update"},"children":[{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15 19C15 21.2091 16.7909 23 19 23C21.2091 23 23 21.2091 23 19C23 16.7909 21.2091 15 19 15H16.75M18 13L16 15L18 17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20.5 9V2.5H3.5V21.5H11M8 8H16M8 12H12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const DocumentUpdateIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'document-update',
    ref,
    icon: element,
  },
));

DocumentUpdateIcon.displayName = 'DocumentUpdateIcon';

export default DocumentUpdateIcon;
